import React, { useEffect, useState, useRef } from 'react';
import Modal from 'components/shared/Modal/Modal';
import { Status } from 'common/utils/constants';
import { HEATMAP_RETRIEVE_SCREEN_INDEXES } from '../HeatmapViewAndExportModal/utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { doGetLatestHeatmapFromDevice, doPersistRasterRecord, updateStatus } from 'redux/actions';
import HeatmapRetrieveSetTimeoutScreen from './HeatmapRetrieveSetTimeoutScreen/HeatmapRetrieveSetTimeoutScreen';
// import HeatmapRetrieveProgressScreen from './HeatmapRetrieveProgressScreen/HeatmapRetrieveProgressScreen';
import HeatmapRetrieveSuccessScreen from './HeatmapRetrieveSuccessScreen/HeatmapRetrieveSuccessScreen';
import HeatmapRetrieveDuplicateNotificationScreen from './HeatmapRetrieveDuplicateNotificationScreen/HeatmapRetrieveDuplicateNotificationScreen';
import HeatmapRetrieveErrorScreen from './HeatmapRetrieveErrorScreen/HeatmapRetrieveErrorScreen';
import './HeatmapRetrieveModal.css';

let timeCount = 0;
let closeModalSeconds = 5;

const HeatmapRetrieveModal = (props) => {
  const [timeoutMinute, setTimeoutMinute] = useState(2);
  const [screenIndex, setScreenIndex] = useState(HEATMAP_RETRIEVE_SCREEN_INDEXES.SETTIMEOUT);
  const [errorCode, setErrorCode] = useState(null);
  const [saveDuplicateErrorCode, setSaveDuplicateErrorCode] = useState(null);
  const [isRetrieveBtnTriggered, setIsRetrieveBtnTriggered] = useState(false);
  const [isDuplicatedHeatmap, setIsDuplicatedHeatmap] = useState(false);
  const [duplicatePersistUri, setDuplicatePersistUri] = useState(null);
  const [persistUriCountdown, setPersistUriCountdown] = useState(0);
  const dispatch = useDispatch();

  const autoCloseModalInterval = useRef(null);
  const retrieveHeatmapTimeout = useRef(null);
  const progressInterval = useRef(null);
  const retrieveHeatmapTimeout2 = useRef(null);
  const abortController = useRef(null);

  const getLatestHeatmapFromDeviceStatusName = `GET-LatestHeatmapFromDevice-${props.targetDevice}`;
  const getLatestHeatmapFromDeviceStatus = useSelector((store) => store.statuses[getLatestHeatmapFromDeviceStatusName]);
  const persistRasterRecordStatusName = `PATCH-PersistRasterRecord-${props.targetDevice}`;
  const persistRasterRecordStatus = useSelector((store) => store.statuses[persistRasterRecordStatusName]);

  let isFetching = getLatestHeatmapFromDeviceStatus === Status.PENDING;
  let isSucceeded = getLatestHeatmapFromDeviceStatus === Status.SUCCESS;
  let isFailed = getLatestHeatmapFromDeviceStatus === Status.FAILURE;
  let closeDuplicateScreenSeconds = 180;
  let displayCountdownSeconds = closeDuplicateScreenSeconds - 30;

  useEffect(() => {
    if ((isFetching || isFailed) && !isSucceeded && !isRetrieveBtnTriggered) {
      retrieveHeatmapTimeout2.current = setTimeout(() => {
        if ((!getLatestHeatmapFromDeviceStatus || isFetching || isFailed) && !isSucceeded) {
          setScreenIndex(HEATMAP_RETRIEVE_SCREEN_INDEXES.ERROR);
          setErrorCode(408);
          clearTimeout(retrieveHeatmapTimeout2.current);
        }
      }, timeoutMinute * 1000 * 60);
    } else if (
      isSucceeded &&
      (screenIndex !== HEATMAP_RETRIEVE_SCREEN_INDEXES.SUCCESS ||
        screenIndex !== HEATMAP_RETRIEVE_SCREEN_INDEXES.DUPLICATE)
    ) {
      screenIndex !== HEATMAP_RETRIEVE_SCREEN_INDEXES.ERROR &&
        setScreenIndex(
          isDuplicatedHeatmap ? HEATMAP_RETRIEVE_SCREEN_INDEXES.DUPLICATE : HEATMAP_RETRIEVE_SCREEN_INDEXES.SUCCESS
        );
    }
  }, [getLatestHeatmapFromDeviceStatus, screenIndex, isDuplicatedHeatmap, timeoutMinute, isRetrieveBtnTriggered]);

  const resetStates = () => {
    dispatch(updateStatus(getLatestHeatmapFromDeviceStatusName, Status.NONE));
    dispatch(updateStatus(persistRasterRecordStatusName, Status.NONE));
    setTimeoutMinute(2);
    setScreenIndex(HEATMAP_RETRIEVE_SCREEN_INDEXES.SETTIMEOUT);
    setErrorCode(null);
    setSaveDuplicateErrorCode(null);
    setIsRetrieveBtnTriggered(false);
    setIsDuplicatedHeatmap(false);
    setDuplicatePersistUri(null);
    setPersistUriCountdown(0);
    clearTimeoutAndInterval();
  };

  const cancelRequest = () => abortController.current && abortController.current.abort();

  const clearTimeoutAndInterval = () => {
    timeCount = 0;
    retrieveHeatmapTimeout && retrieveHeatmapTimeout.current && clearTimeout(retrieveHeatmapTimeout.current);
    progressInterval && progressInterval.current && clearInterval(progressInterval.current);
    retrieveHeatmapTimeout2 && retrieveHeatmapTimeout2.current && clearTimeout(retrieveHeatmapTimeout2);
    autoCloseModalInterval && autoCloseModalInterval.current && clearInterval(autoCloseModalInterval.current);
  };

  const retrieveHeatmapAction = (fromErrorScreen = false) => {
    // setScreenIndex(HEATMAP_RETRIEVE_SCREEN_INDEXES.IN_PROGRESS);

    // retrieveHeatmapTimeout.current = setTimeout(() => {
    let cb_success = (res) => {
      retrieveHeatmapTimeout2 && retrieveHeatmapTimeout2.current && clearTimeout(retrieveHeatmapTimeout2.current);
      let persistUri = res?.persistUri;
      let isDuplicate = res?.isDuplicate;
      setIsDuplicatedHeatmap(isDuplicate);
      setDuplicatePersistUri(persistUri);
      //   screenIndex !== HEATMAP_RETRIEVE_SCREEN_INDEXES.ERROR &&
      //     setScreenIndex(isDuplicate ? HEATMAP_RETRIEVE_SCREEN_INDEXES.DUPLICATE : HEATMAP_RETRIEVE_SCREEN_INDEXES.SUCCESS);
      autoCloseModalInterval.current = setInterval(() => {
        timeCount++;
        setPersistUriCountdown(timeCount);
        console.log('closing modal in: ', (isDuplicate ? closeDuplicateScreenSeconds : closeModalSeconds) - timeCount);

        if (timeCount === (isDuplicate ? closeDuplicateScreenSeconds : closeModalSeconds)) {
          clearTimeoutAndInterval();
          timeCount = 0;
          onCloseScreen();
          !isDuplicate && props.fetchRasterRecordsForDevice();
        }
      }, 1000);
    };

    let cb_failed = (errorCode) => {
      console.log('error in cb_failed', errorCode);
      setErrorCode(errorCode);
      setScreenIndex(HEATMAP_RETRIEVE_SCREEN_INDEXES.ERROR);
    };
    abortController.current = new AbortController();
    dispatch(doGetLatestHeatmapFromDevice(props.targetDevice, cb_success, cb_failed, abortController));
    // }, timeoutMinute * 1000 * 60);
  };

  const handleSaveDuplicate = () => {
    let cb_success = (res) => {
      onCloseScreen();
    };

    let cb_failed = (e) => {
      setSaveDuplicateErrorCode(e.message);
      setScreenIndex(HEATMAP_RETRIEVE_SCREEN_INDEXES.ERROR);
    };

    duplicatePersistUri &&
      props.targetDevice &&
      dispatch(doPersistRasterRecord(duplicatePersistUri, props.targetDevice, cb_success, cb_failed));
  };

  const onCloseScreen = (fromErrorScreen = false) => {
    timeCount = 0;
    dispatch(updateStatus(getLatestHeatmapFromDeviceStatusName, Status.NONE));
    clearTimeoutAndInterval();
    cancelRequest();
    if (
      screenIndex === HEATMAP_RETRIEVE_SCREEN_INDEXES.SUCCESS ||
      (isDuplicatedHeatmap && screenIndex === HEATMAP_RETRIEVE_SCREEN_INDEXES.DUPLICATE)
    ) {
      props.setIsHeatmapViewAndExportModalOpen(true);
      props.fetchRasterRecordsForDevice();
    }
    resetStates();
    !fromErrorScreen && props.onClose();
  };

  let modalWidth = screenIndex === HEATMAP_RETRIEVE_SCREEN_INDEXES.DUPLICATE ? 525 : 454;
  let modalHeight =
    screenIndex === HEATMAP_RETRIEVE_SCREEN_INDEXES.DUPLICATE
      ? persistUriCountdown >= displayCountdownSeconds
        ? 315
        : 282
      : 238;

  return (
    <Modal animateX={false} close={onCloseScreen} noPadding height={modalHeight} width={modalWidth}>
      {screenIndex === HEATMAP_RETRIEVE_SCREEN_INDEXES.SETTIMEOUT && (
        <HeatmapRetrieveSetTimeoutScreen
          donorDevice={props.targetDevice}
          onClose={onCloseScreen}
          retrieveHeatmapAction={retrieveHeatmapAction}
          timeoutMinute={timeoutMinute}
          setTimeoutMinute={setTimeoutMinute}
          isFetching={isFetching}
        />
      )}
      {/* {screenIndex === HEATMAP_RETRIEVE_SCREEN_INDEXES.IN_PROGRESS && (
        <HeatmapRetrieveProgressScreen
          onClose={onCloseScreen}
          timeoutMinute={timeoutMinute}
          donorDevice={props.targetDevice}
          progressInterval={progressInterval}
        />
      )} */}
      {screenIndex === HEATMAP_RETRIEVE_SCREEN_INDEXES.SUCCESS && (
        <HeatmapRetrieveSuccessScreen onClose={onCloseScreen} />
      )}
      {screenIndex === HEATMAP_RETRIEVE_SCREEN_INDEXES.DUPLICATE && (
        <HeatmapRetrieveDuplicateNotificationScreen
          onClose={onCloseScreen}
          handleSaveDuplicate={handleSaveDuplicate}
          persistUriCountdown={persistUriCountdown}
          persistRasterRecordStatus={persistRasterRecordStatus}
          closeDuplicateScreenSeconds={closeDuplicateScreenSeconds}
          displayCountdownSeconds={displayCountdownSeconds}
        />
      )}
      {screenIndex === HEATMAP_RETRIEVE_SCREEN_INDEXES.ERROR && (
        <HeatmapRetrieveErrorScreen
          onClose={(fromErrorScreen) => onCloseScreen(fromErrorScreen)}
          errorCode={errorCode}
          retrieveHeatmapAction={retrieveHeatmapAction}
          cancelRequest={cancelRequest}
          getLatestHeatmapFromDeviceStatusName={getLatestHeatmapFromDeviceStatusName}
          clearTimeoutAndInterval={clearTimeoutAndInterval}
          resetStates={resetStates}
          setIsRetrieveBtnTriggered={setIsRetrieveBtnTriggered}
          saveDuplicateErrorCode={saveDuplicateErrorCode}
        />
      )}
    </Modal>
  );
};

export default React.memo(HeatmapRetrieveModal);
